module.exports = __webpack_public_path__ + "img/wheat-awn-slash.b8d2c0ab.svg";